import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import { App } from "@components/App";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const fontFamilies: string[] = ["Montserrat", "Helvetica", "Arial", "sans-serif"];
const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <ThemeProvider
            theme={createTheme({
                typography: {
                    fontFamily: fontFamilies.join(","),
                },
            })}
        >
            <App />
        </ThemeProvider>
    </React.StrictMode>,
);
